import Logoblu from '../logo_blu.png';


export const viewLIQUEReport = (data = {}, tipoProva,nomeProva,committente,localita,indirizzo,falda) => {

   // Apriamo una nuova finestra per il report
  const iframe = document.getElementById("reportFrameipl");
  if (!iframe) return;
  const win = iframe.contentWindow;
  const reportDoc = win.document;
  
  const result = data.result || {}; // 👈 QUI usi .result

  const tipologiaVal = tipoProva;
  const nomeProvaVal = nomeProva;
  const committenteVal = committente;
  const luogoVal = localita;
  const indirizzoVal = indirizzo;
  const faldaVal = falda;
  const preforo = result.Preforo;
  const amax = result.Acc;
  const mwmax = result.Mw;
  const ipl = result.IndiceLiquefazione;
  const mtd = result.metodo;
  const mtddesc =
      mtd === 0
        ? "Boulanger & Idriss (2014)"
        : mtd === 1
        ? "Robertson & Wride (1998)"
        : "Metodo non riconosciuto";
  const fcLabel = (mtd === 0) ? "FC" : "F%";

  const ced=result.cedimento;
  let cedRow = "";

    if (ced !== -1 && ced !== "-1") {
      cedRow = `
        <tr>
          <td>Cedimento Free Field</td>
          <td><div class="readonly">${ced} cm</div></td>
        </tr>
      `;
    }

  // Crea i dati ordinati prima di passarli
  const combinedData = (result.Hcsr || []).map((p, i) => ({
    Hcsr: p,
    csr: result.CSR?.[i],
    q: result.Q[i],
    fc: mtd === 0 ? result.FC?.[i] ?? null : null,
    f:  mtd === 1 ? result.F?.[i] ?? null : null,
    ic: result.Ic[i],
    fsl: result.Fsl[i],
    ipl: result.Ipl[i],

  })).sort((a, b) => b.Hcsr - a.Hcsr);


  const crrData = (result.Hcrr || []).map((h, i) => ({
      Hcrr: h,
      crr: result.CRR[i],

      Hcsr: h,
      csr: result.CSR?.[i]
    }));

  const HcsrSorted = combinedData.map(d => d.Hcsr);
  const CSRSorted  = combinedData.map(d => d.csr);
  const QSorted    = combinedData.map(d => d.q);
  const FCSorted   = combinedData.map(d => d.fc ?? null);
  const FSorted    = combinedData.map(d => d.f ?? null);
  const IcSorted   = combinedData.map(d => d.ic);
  const FslSorted  = combinedData.map(d => d.fsl);
  const IplSorted  = combinedData.map(d => d.ipl);
  // CRR separato
  const HcrrSorted = crrData.map(d => d.Hcrr);
  const CRRSorted  = crrData.map(d => d.crr);


  const maxProf = Math.max(...HcsrSorted);
  const minProf = Math.min(...HcsrSorted);

  // Data e ora odierna
  const now = new Date();
  const dateStr = now.toLocaleDateString('it-IT');
  const timeStr = now.toLocaleTimeString('it-IT');


  const tableRows = (result.Hcsr || [])
      .map((p, i) => ({
        Hcsr: p,
        csr: result.CSR?.[i],
        q: result.Q?.[i],

        // 👉 LOGICA METODO
        f_val: mtd === 0
          ? result.FC?.[i]
          : result.F?.[i],

        ic: result.Ic?.[i],
        fsl: result.Fsl?.[i],
        ipl: result.Ipl?.[i],
      }))
      .sort((a, b) => a.Hcsr - b.Hcsr)
      .map(p => `
        <tr>
          <td>${p.Hcsr != null ? Number(p.Hcsr).toFixed(2) : ''}</td>
          <td>${p.csr != null ? Number(p.csr).toFixed(4) : ''}</td>
          <td>${p.q != null ? Number(p.q).toFixed(2) : ''}</td>

          <!-- 👉 UNA SOLA COLONNA coerente -->
          <td>${p.f_val != null ? Number(p.f_val).toFixed(2) : ''}</td>

          <td>${p.ic != null ? Number(p.ic).toFixed(2) : ''}</td>

          <!-- testo -->
          <td>${p.fsl != null ? String(p.fsl) : ''}</td>

          <td>${p.ipl != null ? Number(p.ipl).toFixed(2) : ''}</td>
        </tr>
      `)
      .join("");


   // tabella paramtri generale
   let paginaTabelladati = '';
    if (HcsrSorted .length > 1) {
      paginaTabelladati = `
      <!-- PAGINA 8 - Orizzontale -->
      <div class="page3">
        <div class="title-left">
            <h2>Report calcolo indice potenziale liquefazione verticale ${nomeProvaVal}</h2>
            <hr>
        </div>
        <table class="data-table small-table" style="margin-top: 50px; margin-bottom: 20px;">
          <thead>
            <tr>
              <th>Prof. (m)</th>
              <th>Q (r.p.c.)</th>
              <th>${fcLabel}</th>
              <th>CSR</th>
              <th>Ic</th>
              <th>Fsl</th>
              <th>Ipl</th>
            </tr>
          </thead>
          <tbody>
            ${tableRows}
          </tbody>
        </table>
      </div>
      `;
    }

  const html=`
    <!DOCTYPE html>
    <html>
      <head>
        <script src="https://cdn.plot.ly/plotly-2.27.1.min.js"></script>
        <style>
          * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
          }
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 0;
            background: white;
          }

          /* Pulsanti a destra */
          .controls {
            position: fixed;
            top: 10px;
            right: 10px;
            z-index: 1000;
            display: flex;
            gap: 5px;
            background: rgba(255,255,255,0.9);
            padding: 5px;
            border-radius: 8px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          }

          .print-btn {
            background: #12455b;
            color: white;
            border: none;
            width: 32px;
            height: 32px;
            border-radius: 5px;
            font-size: 16px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .print-btn:hover {
            background: #0d3445;
          }

          /* PAGINE - senza salti automatici */
          @page {
            size: A4;
            margin: 1.5cm;
          }

          /* Pagina 0 - Verticale legenda parametri*/
          .page0 {
            page: A4;
            min-height: 100vh;
            position: relative;
            padding: 20px;
          }

          /* Pagina 1 - Verticale */
          .page1 {
            page: A4;
            min-height: 100vh;
            position: relative;
            padding: 20px;
          }

          /* Pagina 2 - Orizzontale */
          .page2 {
              page: landscape;
              size: A4 landscape;
              position: relative;
              padding: 5px 0px;
              display: flex;
              flex-direction: column;
              width: 100%;
              box-sizing: border-box; /* evita che il padding allarghi il box */
            }

          .page3 {
              page: landscape;
              size: A4 landscape;
              transform: scale(0.75);
              transform-origin: top left;
              width: 130%;
            }

          .content-wrapper {
              display: flex;
              flex-direction: column;
              flex: 1;
            }

          @page landscape {
            size: A4 landscape;
            margin: 1.5cm;
          }

          /* Logo solo prima pagina */
          .logo {
            position: absolute;
            bottom: 20px;
            right: 20px;
            width: 33px;
            height: auto;
            opacity: 0.7;
          }

          .logo img {
            width: 100%;
            height: auto;
            display: block;
          }

          /* Pagina 1 - Stili */
          .header {
            text-align: center;
            margin-bottom: 20px;
          }

          .header h1 {
            font-size: 28px;
            color: #333;
            margin-bottom: 5px;
          }

          .header h2 {
            font-size: 20px;
            color: #666;
            font-weight: normal;
          }

          .delimiter {
            text-align: right;
            font-size: 12px;
            color: #666;
            margin-bottom: 20px;
            border-bottom: 1px solid #ccc;
            padding-bottom: 5px;
          }

          .data-table {
            width: 100%;
            border-collapse: collapse;
          }

          .data-table td {
            padding: 8px 12px;
            border: 1px solid #ddd;
          }

          .data-table td:first-child {
            font-weight: bold;
            background-color: #f5f5f5;
            width: 150px;
          }

          .data-table input {
            width: 100%;
            border: none;
            padding: 5px;
            font-size: 14px;
            background: transparent;
          }

          .data-table .readonly {
            background-color: #f9f9f9;
            color: #666;
            font-style: italic;
            padding: 5px;
          }

          /* Pagina 2 - Stili */
          .title-left {
            text-align: left;
            margin: 0 !important;
            padding-bottom: 10 !important;
          }

          .title-left h2 {
              font-size: 20px;
              color: #333;
              margin: 0 !important;
              padding: 0 !important;
              line-height: 1.5 !important;
            }

          .title-left hr {
              width: 40%;
               margin: 2px 0 2px 0 !important;  /* Spazio minimo */
               padding: 0 !important;
              border: 1px solid #12455b;
            }

          /* Container grafici */
          .charts-container {
              margin: 0 !important;
              padding-bottom: 10 !important;
              height: auto;
              min-height: 0;
              display: flex;
              flex-wrap: wrap;
              gap: 5px;  /* Riduci gap se necessario */
              justify-content: center;  /* centra orizzontalmente */
              align-items: center;
            }

          .chart-item {
            width: calc(50% - 5px);
            height: 350px;
            background: white;
            border: 1px solid #eee;
            border-radius: 4px;
            padding: 5px;
          }

          .chart-item .plot-container {
            width: 100%;
            height: 100%;
          }

          .didascalia {
              margin: 0 !important;
              padding: 0 !important;
              line-height: 1 !important;
              font-size: 11px;
              text-align: center; /* centra il testo */
           }

          .page-number {
              font-size: 8px;
              color: #666;
            }

          @media print {
            .controls {
              display: none;
            }
            body {
              margin: 0;
              padding: 0;
            }
            .page1, .page2 {
              box-shadow: none;
              padding: 0.5cm;
            }
            .chart-item {
              border: none;
              height: 380px;
            }
          }

          /* Titolo principale leggermente più piccolo */
            .h1bis {
              font-size: 18px; /* ridotto rispetto a h1 normale */
              margin-bottom: 0.3em;
              font-weight: bold;
            }

            /* Tabella con font più piccolo */
            .data-table.small-table {
              font-size: 12px;
              border-collapse: collapse;
              width: 100%;
            }

            /* Bordo e padding generale */
            .data-table.small-table th,
            .data-table.small-table td {
              padding: 6px 8px;
              border: 1px solid #ccc;
            }

            /* Riga intestazione grigia solo per i titoli */
            .data-table.small-table thead th {
              background-color: #e0e0e0;
              font-weight: bold;
              text-align: left;

            }

        </style>
      </head>
      <body>
        <!-- Pulsanti -->
        <div class="controls">
          <button class="print-btn" onclick="window.print()" title="Salva PDF">💾</button>
          <button class="print-btn" onclick="window.close()" title="Chiudi">✖</button>
          <button class="print-btn" onclick="resetEditableFields()" title="Reset Campi">↺</button>
        </div>

        <!-- PAGINA 1 - Verticale -->
        <div class="page1">
          <div class="delimiter">
            <span>V.E.S. - Virtual Earth Suite</span>
            <span>Sviluppato dal Dott. Geol. Umberto Grechi</span>
          </div>

          <div class="header">
            <h1>V.E.S.</h1>
            <h2>Verifica indice potenziale di liquefazione</h2>
          </div>

          <table class="data-table">
            <tr><td>Committente</td><td><input type="text" id="committente" value="${committenteVal}"></td></tr>
            <tr><td>Località</td><td><input type="text" id="localita" value="${luogoVal}"></td></tr>
            <tr><td>Via</td><td><input type="text" id="via" value="${indirizzoVal}"></td></tr>
            <tr><td>Nome prova</td><td><input type="text" id="nome" value="${nomeProvaVal}"></td></tr>
            <tr><td>Tipo prova</td><td><div class="readonly">${tipologiaVal}</div></td></tr>
            <tr><td>Falda m da p.c.</td><td><div class="readonly">${faldaVal}</div></td></tr>
            <tr><td>Amax/g</td><td><div class="readonly">${amax}</div></td></tr>
            <tr><td>Magnitudo</td><td><div class="readonly">${mwmax}</div></td></tr>
            <tr><td>Metodo</td><td><div class="readonly">${mtddesc}</div></td></tr>
            <tr><td>IPL (Sonmez)</td><td><div class="readonly">${ipl}</div></td></tr>
            ${cedRow}
            <tr><td>Data elaborazione</td><td><div class="readonly">${dateStr}</div></td></tr>
          </table>

          <div class="logo">
            <img src="${Logoblu}" alt="Logo">
          </div>
        </div>

        <!-- PAGINA 2 - Orizzontale parametri-->
        <div class="page2">
          <div class="content-wrapper" >
            <div class="title-left">
              <h2>Verticale prova penetrometrica ${nomeProvaVal}</h2>
              <hr>
            </div>

            <div class="chart-legend-wrapper"
                 style="display:flex; justify-content:center; align-items:center; gap:20px; margin-bottom:25px;">
                <div class="charts-container" id="chartsContainer1" >
                  <!-- I grafici verranno inseriti dinamicamente -->
                </div>
                <div id="external-legend"></div>
                </div>
            <div class="didascalia">
              Fig1 - A sinistra grafico CSR vs CRR - profondità; A destra Fattore di sicurezza a liquefazione - profondità
            </div>
          </div>
        </div>

        <!-- PAGINA finale - Orizzontale -->
        ${paginaTabelladati}


        <!-- PAGINA LEGGENDA - Verticale -->
        <div class="page0">
          <div class="delimiter">
            <span>V.E.S. - Virtual Earth Suite</span>
            <span>Sviluppato dal Dott. Geol. Umberto Grechi</span>
          </div>

        <div class="header">
            <h1 class="h1bis">Legenda parametri elaborati</h1>
          </div>
            <table class="data-table small-table">
              <thead>
                <tr>
                  <th>Variabile</th>
                  <th>Unità di misura</th>
                  <th>Descrizione</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Prof.</td>
                  <td>(m)</td>
                  <td>profonditòà da p.c.</td>
                </tr>
                <tr>
                  <td>Q</td>
                  <td>[r.p.c.]</td>
                  <td>Resistenza alla punta corretta</td>
                </tr>
                <tr>
                  <td>${fcLabel}</td>
                  <td>[-]</td>
                  <td>Contenuto frazione fine</td>
                </tr>
                <tr>
                  <td>CSR</td>
                  <td>[-]</td>
                  <td>rapporto di sollecitazione ciclica</td>
                </tr>
                <tr>
                  <td>Ic</td>
                  <td>[-]</td>
                  <td>Indice di comportamento</td>
                </tr>
                <tr>
                  <td>Fsl</td>
                  <td>[-]</td>
                  <td>Fattore sicurezza liquefazione</td>
                </tr>
                <tr>
                  <td>Ipl</td>
                  <td>[-]</td>
                  <td>Indice potenziale liquefazione</td>
                </tr>
               </tbody>
            </table>

          <div class="logo">
            <img src="${Logoblu}" alt="Logo">
          </div>
        </div>



        <script>
          // usa window.xxx o var per evitare il problema
          var pages = document.querySelectorAll('.page1, .page2');
          pages.forEach(function(page, index) {
            var pageNumberDiv = document.createElement('div');
            pageNumberDiv.className = 'page-number';
            pageNumberDiv.style.position = 'absolute';
            pageNumberDiv.style.bottom = '5px';
            pageNumberDiv.style.left = '10px';
            pageNumberDiv.style.fontSize = '9px';
            pageNumberDiv.style.color = '#666';
            pageNumberDiv.innerText = (index + 1) + " / " + pages.length;
            page.appendChild(pageNumberDiv);
          });

          // Data di stampa
          var dataEl = document.getElementById('dataStampa');
          if (dataEl) {
            dataEl.innerText = "${dateStr} ${timeStr}";
          }
        </script>

        <!-- NESSUN ALTRO DIVISORE - così finisce qui -->

        <script>
            window.HcsrSorted = ${JSON.stringify(HcsrSorted)};

            window.QSorted   = ${JSON.stringify(QSorted)};

            window.CSRSorted  = ${JSON.stringify(CSRSorted)};

            window.FCSorted   = ${JSON.stringify(FCSorted)};
            window.FSorted    = ${JSON.stringify(FSorted)};

            window.IcSorted   = ${JSON.stringify(IcSorted)};
            window.FslSorted  = ${JSON.stringify(FslSorted)};
            window.IplSorted  = ${JSON.stringify(IplSorted)};

            window.HcrrSorted = ${JSON.stringify(HcrrSorted)};
            window.CRRSorted  = ${JSON.stringify(CRRSorted)};

            window.maxProf = ${maxProf};
            window.minProf = ${minProf};


          window.CHART_WIDTH = 250;
          window.CHART_HEIGHT = 570;

          window.resetEditableFields = function() {
            document.getElementById('committente').value = '';
            document.getElementById('localita').value = '';
            document.getElementById('via').value = '';
            document.getElementById('nome').value = '';
            localStorage.removeItem('cptReportData');
          };

          function loadSavedData() {
            const saved = localStorage.getItem('cptReportData');
            if (saved) {
              const data = JSON.parse(saved);
              document.getElementById('committente').value = data.committente || '';
              document.getElementById('localita').value = data.localita || '';
              document.getElementById('via').value = data.via || '';
              document.getElementById('nome').value = data.nome || '';
            }
          }

          function saveData() {
            const data = {
              committente: document.getElementById('committente').value,
              localita: document.getElementById('localita').value,
              via: document.getElementById('via').value,
              nome: document.getElementById('nome').value
            };
            localStorage.setItem('cptReportData', JSON.stringify(data));
          }

          window.charts1 = [
              {
                id: 'csrcrrChart',
                type: 'csr_crr',
                xLabel: 'CSR - CRR'
              },
              {
                id: 'fslChart',
                type: 'fsl',
                xLabel: 'Fsl'
              }
          ];

        function createCharts1() {

          const container1 = document.getElementById('chartsContainer1');
          if (!container1) return;

          container1.innerHTML = '';

          // =========================
          // CREATE CONTAINERS
          // =========================
          charts1.forEach((chart) => {

            const chartDiv = document.createElement('div');
            chartDiv.className = 'chart-item';
            chartDiv.style.width = CHART_WIDTH + 'px';
            chartDiv.style.height = CHART_HEIGHT + 'px';
            chartDiv.style.display = 'inline-block';

            const plotDiv = document.createElement('div');
            plotDiv.id = chart.id;
            plotDiv.className = 'plot-container';

            chartDiv.appendChild(plotDiv);
            container1.appendChild(chartDiv);
          });

          // =========================
          // RENDER
          // =========================
          charts1.forEach((chart) => {

            let traces = [];
            let xMaxLocal = 1;
            let shapesLocal = [];

            // =====================================================
            // 📊 CSR - CRR
            // =====================================================
            if (chart.type === 'csr_crr') {

              traces.push({
                x: CSRSorted,
                y: HcsrSorted,
                type: 'scatter',
                mode: 'lines',
                line: { color: '#1a72c9', width: 2 },
                name: 'CSR'
              });

              let x_safe = [], y_safe = [];
              let x_liq = [], y_liq = [];

              function getCSR(depth) {
                let bestIdx = -1;
                let minDiff = Infinity;

                for (let i = 0; i < HcsrSorted.length; i++) {
                  let d = Math.abs(HcsrSorted[i] - depth);
                  if (d < minDiff) {
                    minDiff = d;
                    bestIdx = i;
                  }
                }

                return bestIdx !== -1 ? CSRSorted[bestIdx] : null;
              }

              for (let i = 0; i < CRRSorted.length; i++) {

                let crr = Number(CRRSorted[i]);
                let depth = HcrrSorted[i];

                if (!isFinite(crr) || crr === 0) continue;

                let csr = Number(getCSR(depth));
                if (!isFinite(csr)) continue;

                if (crr >= csr) {
                  x_safe.push(crr);
                  y_safe.push(depth);
                } else {
                  x_liq.push(crr);
                  y_liq.push(depth);
                }
              }

              traces.push({
                x: x_safe,
                y: y_safe,
                type: 'scatter',
                mode: 'markers',
                marker: { size: 3, color: '#2ca02c' },
                name: 'No liquefazione'
              });

              traces.push({
                x: x_liq,
                y: y_liq,
                type: 'scatter',
                mode: 'markers',
                marker: { size: 3, color: '#d62728' },
                name: 'Liquefazione'
              });

              shapesLocal = [
                {
                  type: 'line',
                  x0: 1,
                  x1: 1,
                  y0: 0,
                  y1: maxProf,
                  line: { color: 'black', width: 1 }
                }
              ];
            }

            // =====================================================
            // 📊 FSL
            // =====================================================
            if (chart.type === 'fsl') {

              const X_LIMIT = 2;
              const X_OUT = 1.8;

              let x_red = [], y_red = [];
              let x_orange = [], y_orange = [];
              let x_green = [], y_green = [];
              let x_out = [], y_out = [];

              let maxFsl = 0;

              for (let i = 0; i < FslSorted.length; i++) {

                let val = Number(FslSorted[i]);
                let depth = HcsrSorted[i];

                if (!isFinite(val) || val === 0) continue;

                if (val > maxFsl) maxFsl = val;

                // 👉 OUTLIER (>2)
                if (val > X_LIMIT) {
                  x_out.push(X_OUT);
                  y_out.push(depth);
                  continue;
                }

                if (val < 1) {
                  x_red.push(val);
                  y_red.push(depth);
                }
                else if (val < 1.2) {
                  x_orange.push(val);
                  y_orange.push(depth);
                }
                else {
                  x_green.push(val);
                  y_green.push(depth);
                }
              }

              // =========================
              // X MAX LIMITATO
              // =========================
              xMaxLocal = (maxFsl < 1.2) ? 1.5 : Math.min(maxFsl + 0.1, X_LIMIT);
              if (!isFinite(xMaxLocal)) xMaxLocal = 1.5;

              // =========================
              // TRACES
              // =========================
              traces.push({
                x: x_red,
                y: y_red,
                type: 'scatter',
                mode: 'markers',
                marker: { size: 3, color: '#d62728' },
                name: 'Fsl < 1'
              });

              traces.push({
                x: x_orange,
                y: y_orange,
                type: 'scatter',
                mode: 'markers',
                marker: { size: 3, color: '#ff9900' },
                name: '1 - 1.2'
              });

              traces.push({
                x: x_green,
                y: y_green,
                type: 'scatter',
                mode: 'markers',
                marker: { size: 3, color: '#2ca02c' },
                name: '≥ 1.2'
              });

              // 👉 OUTLIER VISIVI (triangolo verde a 1.8)
              traces.push({
                x: x_out,
                y: y_out,
                type: 'scatter',
                mode: 'markers',
                marker: {
                  size: 6,
                  color: '#2ca02c',
                  symbol: 'triangle-right'
                },
                name: '> 2'
              });

              // =========================
              // SHAPES
              // =========================
              shapesLocal = [
                {
                  type: 'line',
                  x0: 1,
                  x1: 1,
                  y0: 0,
                  y1: maxProf,
                  line: { color: '#d62728', width: 1.5, dash: 'dot' }
                },
                {
                  type: 'line',
                  x0: 1.2,
                  x1: 1.2,
                  y0: 0,
                  y1: maxProf,
                  line: { color: '#2ca02c', width: 1.5, dash: 'dot' }
                },
                {
                  type: 'line',
                  x0: xMaxLocal,
                  x1: xMaxLocal,
                  y0: 0,
                  y1: maxProf,
                  line: { color: 'black', width: 1 }
                },
                {
                  type: 'line',
                  x0: X_LIMIT,
                  x1: X_LIMIT,
                  y0: 0,
                  y1: maxProf,
                  line: { color: 'black', width: 1, dash: 'dash' }
                }
              ];
            }

            // =========================
            // PLOTLY RENDER
            // =========================
            Plotly.newPlot(chart.id, traces, {

              width: CHART_WIDTH - 20,
              height: CHART_HEIGHT - 20,

              xaxis: {
                title: {
                  text: chart.xLabel,
                  font: { family: 'Roboto, sans-serif', size: 9 }
                },

                range: [0, xMaxLocal],

                tickvals: chart.type === 'fsl'
                  ? [0, 0.5, 1, 1.2, xMaxLocal]
                  : undefined,

                ticktext: chart.type === 'fsl'
                  ? ['0', '0.5', '1', '1.2',
                     (isFinite(xMaxLocal) ? xMaxLocal : 1.5).toFixed(2)]
                  : undefined,

                tickangle: 0,
                automargin: true,
                tickmode: 'array',
                ticklabeloverflow: 'allow',

                showgrid: true,
                gridcolor: '#888888',
                griddash: 'dash',
                tickfont: { family: 'Roboto, sans-serif', size: 8 },
                linecolor: 'black',
                linewidth: 1
              },

              yaxis: {
                title: {
                  text: 'Profondità [m]',
                  font: { family: 'Roboto, sans-serif', size: 9 }
                },
                range: [maxProf, 0],
                showgrid: true,
                gridcolor: '#888888',
                griddash: 'dash',
                dtick: 1,
                tickfont: { family: 'Roboto, sans-serif', size: 8 },
                linecolor: 'black',
                linewidth: 1
              },

              margin: { t: 20, r: 10, l: 30, b: 30 },
              showlegend: false,
              shapes: shapesLocal
            });

          });
        }

        function createExternalLegend(containerId) {

          const container = document.getElementById(containerId);
          if (!container) return;

          container.innerHTML = '';

          const title = document.createElement('div');
          title.textContent = 'Legenda';
          title.style.fontWeight = 'bold';
          title.style.fontSize = '12px';
          title.style.marginBottom = '10px';
          title.style.fontFamily = 'Roboto, sans-serif';
          container.appendChild(title);

          function addLine(color, label) {

            const item = document.createElement('div');
            item.style.display = 'flex';
            item.style.alignItems = 'center';
            item.style.marginBottom = '6px';
            item.style.fontSize = '10px';
            item.style.fontFamily = 'Roboto, sans-serif';

            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('width', '24');
            svg.setAttribute('height', '10');

            const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
            line.setAttribute('x1', '0');
            line.setAttribute('y1', '5');
            line.setAttribute('x2', '24');
            line.setAttribute('y2', '5');
            line.setAttribute('stroke', color);
            line.setAttribute('stroke-width', '2');

            svg.appendChild(line);

            const text = document.createElement('span');
            text.textContent = label;
            text.style.marginLeft = '8px';

            item.appendChild(svg);
            item.appendChild(text);
            container.appendChild(item);
          }

          function addPoint(color, label) {

            const item = document.createElement('div');
            item.style.display = 'flex';
            item.style.alignItems = 'center';
            item.style.marginBottom = '6px';
            item.style.fontSize = '10px';
            item.style.fontFamily = 'Roboto, sans-serif';

            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('width', '14');
            svg.setAttribute('height', '14');

            const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
            circle.setAttribute('cx', '7');
            circle.setAttribute('cy', '7');
            circle.setAttribute('r', '4');
            circle.setAttribute('fill', color);

            svg.appendChild(circle);

            const text = document.createElement('span');
            text.textContent = label;
            text.style.marginLeft = '8px';

            item.appendChild(svg);
            item.appendChild(text);
            container.appendChild(item);
          }

          // 👉 NUOVA FUNZIONE TRIANGOLO
          function addTriangle(color, label) {

            const item = document.createElement('div');
            item.style.display = 'flex';
            item.style.alignItems = 'center';
            item.style.marginBottom = '6px';
            item.style.fontSize = '10px';
            item.style.fontFamily = 'Roboto, sans-serif';

            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('width', '16');
            svg.setAttribute('height', '14');

            const triangle = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
            triangle.setAttribute('points', '3,2 13,7 3,12'); // ▶ triangolo verso dx
            triangle.setAttribute('fill', color);

            svg.appendChild(triangle);

            const text = document.createElement('span');
            text.textContent = label;
            text.style.marginLeft = '8px';

            item.appendChild(svg);
            item.appendChild(text);
            container.appendChild(item);
          }

          // =====================
          // CSR - CRR
          // =====================
          const sec1 = document.createElement('div');
          sec1.textContent = 'CSR - CRR';
          sec1.style.fontWeight = 'bold';
          sec1.style.fontSize = '11px';
          sec1.style.margin = '8px 0 6px 0';
          container.appendChild(sec1);

          addLine('#1a72c9', 'CSR');
          addPoint('#2ca02c', 'CRR non liquefacibile');
          addPoint('#d62728', 'CRR liquefacibile');

          // =====================
          // FSL
          // =====================
          const sec2 = document.createElement('div');
          sec2.textContent = 'FSL';
          sec2.style.fontWeight = 'bold';
          sec2.style.fontSize = '11px';
          sec2.style.margin = '10px 0 6px 0';
          container.appendChild(sec2);

          addPoint('#d62728', 'FSL < 1');
          addPoint('#ff9900', '1 ≤ FSL < 1.2');
          addPoint('#2ca02c', 'FSL ≥ 1.2');

          // 👉 NUOVA VOCE OUTLIER
          addTriangle('#2ca02c', 'FSL > 1.8');
        }



          // Inizializzazione
          loadSavedData();
          createCharts1();
          createExternalLegend('external-legend');


          document.getElementById('committente').addEventListener('input', saveData);
          document.getElementById('localita').addEventListener('input', saveData);
          document.getElementById('via').addEventListener('input', saveData);
          document.getElementById('nome').addEventListener('input', saveData);

        </script>
      </body>
    </html>
  `;
  reportDoc.open();
  reportDoc.write(html); // qui 'html' è la stringa completa con <html>...</html>
  reportDoc.close();
};